import {createContext} from "react";

export const AuthContext = createContext({
    token: null,
    user: {},
    ws: null,
    setUser: () => {},
    setToken: () => {}
});